import React, { createContext, useContext } from 'react'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { useFreshpaintSDK } from '@lyrahealth-inc/shared-app-logic/src/features/freshpaint/hooks/useFreshpaintSDK'

export interface FreshpaintContextValue {
  isReady: boolean
}

const FreshpaintContext = createContext<FreshpaintContextValue>({ isReady: false })

/**
 * Hook to check if Freshpaint SDK is ready.
 * The SDK auto-tracks once loaded; use window.freshpaint directly if needed.
 */
export const useFreshpaint = (): FreshpaintContextValue => {
  return useContext(FreshpaintContext)
}

/**
 * Freshpaint Provider that handles SDK loading.
 * The SDK enables Autotrack, which automatically captures page views and events once loaded.
 * https://documentation.freshpaint.io/integrations/sources/web/javascript
 */
export const FreshpaintProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isFreshpaintEnabled } = useFlags()
  const isReady = useFreshpaintSDK(isFreshpaintEnabled)

  return <FreshpaintContext.Provider value={{ isReady }}>{children}</FreshpaintContext.Provider>
}

export default FreshpaintProvider
